import { Reveal } from "@/components/landing/reveal";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export function LandingCta() {
  return (
    <section
      id="cta"
      data-landing-section="cta"
      className="relative scroll-mt-[72px] border-t border-white/10 bg-black px-6 py-24 sm:px-10 sm:py-32"
    >
      <div className="mx-auto max-w-[1080px]">
        <Reveal>
          <p className="mb-3 text-[11px] font-semibold tracking-[0.16em] text-falcon uppercase">Begin</p>
          <h2 className="max-w-[720px] text-[32px] leading-[1.1] font-bold tracking-[-0.02em] text-white sm:text-[44px]">
            Every board is a Mission.
          </h2>
          <p className="mt-4 max-w-[560px] text-[16px] leading-[1.6] text-white/68">
            Sign in and take the first board from Spec to Track. Guided hardware collab — pcbx.ai · rscircuit.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/login"
              className="inline-flex items-center gap-2 rounded-full border border-falcon bg-falcon px-5 py-2.5 text-[12px] font-semibold tracking-[0.06em] text-white uppercase no-underline"
            >
              Begin Mission
              <ArrowRight className="size-3.5" aria-hidden />
            </Link>
            <Link
              to="/login"
              className="inline-flex items-center rounded-full border border-white/28 px-5 py-2.5 text-[12px] font-semibold tracking-[0.06em] text-white uppercase no-underline"
            >
              Sign in
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function LandingFooter() {
  return (
    <footer
      data-landing-section="footer"
      className="border-t border-white/10 bg-black px-6 py-8 sm:px-10"
    >
      <div className="mx-auto flex max-w-[1080px] flex-wrap items-center justify-between gap-3 text-[12px] tracking-[0.04em] text-white/42">
        <p className="m-0">pcbx.ai · rscircuit</p>
        <Link
          to="/privacy"
          rel="privacy-policy"
          className="text-[12px] tracking-[0.08em] text-white/72 uppercase no-underline hover:text-white"
        >
          Privacy
        </Link>
        <p className="m-0">Team Platform — Every board is a Mission.</p>
      </div>
    </footer>
  );
}
